import { render, staticRenderFns } from "./CommentIng.vue?vue&type=template&id=df1f4c60&scoped=true&"
import script from "./CommentIng.vue?vue&type=script&lang=js&"
export * from "./CommentIng.vue?vue&type=script&lang=js&"
import style0 from "./CommentIng.vue?vue&type=style&index=0&id=df1f4c60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1f4c60",
  null
  
)

export default component.exports